// components/RestaurantPOS/waiters/Footer.jsx
import React from 'react';
import restaurantConfig from '../../config/Organisation_Details';
import logo from '../../assets/logo.jpg';

const Footer = () => {
  return (
    <footer className="epos-footer">
      <div className="footer-left">
        <span className="footer-version">v2.4.0</span>
        <span className="footer-divider"></span>
        <span className="footer-brand">
          {restaurantConfig.name}
        </span>
      </div>
      <div className="footer-right">
         <img src={logo} alt={restaurantConfig.name} className="footer-logo-small" />
        <span className="footer-brand">Designed by</span>
       
        <span className="footer-brand">e-Neurons Technologies Ltd -08065514429</span>
        
        <span className="footer-divider"></span>
        <span className="footer-tagline">{restaurantConfig.slogan}</span>
        <span className="footer-divider"></span>
        <span className="footer-version">{restaurantConfig.phone}</span>
      </div>
    </footer>
  );
};

export default Footer;